import { yupResolver } from "@hookform/resolvers/yup";
import React, { createRef, forwardRef, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { View, StyleSheet, ScrollView, useWindowDimensions, Dimensions } from "react-native";
import { Modal as ModalComponent, RBSheet } from "ui-components";

const webMaxWidth = 1200;
const mobileMaxWidth = 576;

export const BottomSheetModal = forwardRef(({ children, height, onDismiss }: any, ref: any) => {
  const { width: screenWidth } = useWindowDimensions();
  const { height: screenHeight } = Dimensions.get("window");
  let CustomTag = screenWidth <= mobileMaxWidth ? RBSheet : ModalComponent;
  return (
    <CustomTag
      ref={ref}
      height={height || 350}
      showCloseIcon={false}
      customStyles={{
        container: {
          width:
            screenWidth <= mobileMaxWidth
              ? "100%"
              : screenWidth >= mobileMaxWidth && screenWidth <= webMaxWidth
              ? 400
              : 500,
          borderTopRightRadius: 15,
          borderTopLeftRadius: 15,
          padding: 5,
          paddingTop: 15,
        },
      }}
      containerStyle={{
        width:
          screenWidth <= mobileMaxWidth
            ? "100%"
            : screenWidth >= mobileMaxWidth && screenWidth <= webMaxWidth
            ? 400
            : 500,
      }}
      onDismiss={onDismiss}>
      <View style={screenWidth <= mobileMaxWidth ? { flex: 1 } : { maxHeight: screenHeight - 100 }}>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ flexGrow: 1 }}>
          <View style={{ width: "100%", flex: 1 }}>
            {children}
            <View style={{ marginBottom: 10 }} />
          </View>
        </ScrollView>
      </View>
    </CustomTag>
  );
});
